<template>
  <el-dialog
    :title="Baslik"
    :visible="ModalOlayi"
    center
    width="70%">
    <a @click="ModalKapat" class="ModalKapat"><i class="el-icon-close"></i></a>
    <el-collapse accordion v-if="KayitlarDurum">
      <el-collapse-item name="1">
        <template slot="title">
          Geçmiş Kayıtlar
        </template>
        <div class="table-responsive">
          <table class="table table-hover table-sm">
            <thead>
            <tr>
              <th width="50">Kapı No</th>
              <th width="50">Kat</th>
              <th width="50">M2</th>
              <th width="100">Sahip/Kiracı</th>
              <th width="100">Giriş Tarihi</th>
              <th width="100">Çıkış Tarihi</th>
              <th width="500">İsim Soyisim</th>
              <th width="100">Telefon</th>
              <th width="100">TC Kimlik No</th>
            </tr>
            </thead>
            <tbody v-for="Kayit in Kayitlar">
            <tr>
              <td>{{Kayit.kNo}}</td>
              <td>{{Kayit.Kat}}</td>
              <td>{{Kayit.m2}}</td>
              <td>{{Kayit.Sahip==='1'?'Sahip':'Kiracı'}}</td>
              <td>{{Kayit.gTarihi}}</td>
              <td>{{Kayit.cTarihi}}</td>
              <td>{{Kayit.AdSoyad}}</td>
              <td>{{Kayit.Telefon}}</td>
              <td>{{Kayit.vNo}}</td>
            </tr>
            </tbody>
          </table>
        </div>
      </el-collapse-item>
    </el-collapse>
    <el-form :model="data" @submit.prevent.native="Submit(true)" :rules="FormHata" ref="Form">
      <el-row :gutter="20">
        <el-divider content-position="left">Mesken Bilgi</el-divider>
        <el-col :span="2">
          <el-form-item class="Tooltip" label="No" prop="kNo">
            <el-tooltip class="item" effect="dark" content="Kayıtlı daire no var ise yeni mesken eklenmez"
                        placement="top">
              <i class="el-icon-info text-primary cursor-pointer"></i>
            </el-tooltip>
            <el-input v-model="data.kNo"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="2">
          <el-form-item label="Kat" prop="Kat">
            <el-input v-model="data.Kat"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="2">
          <el-form-item label="M2" prop="m2">
            <el-input v-model="data.m2"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="24">
        <el-divider content-position="left">Sahip Bilgi</el-divider>
        <el-col :span="8">
          <el-form-item label="İsim Soyisim" prop="Adi">
            <el-input v-model="data.Adi"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item label="Giriş Tarihi" prop="gTarihi">
            <el-date-picker
              v-model="data.gTarihi"
              type="date"
              placeholder=""
              format="dd.MM.yyyy">
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item label="Çıkış Tarihi" prop="cTarihi">
            <el-date-picker
              v-model="data.cTarihi"
              type="date"
              placeholder=""
              format="dd.MM.yyyy">
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item label="Telefon Numarası" prop="Telefon">
            <el-input v-model="data.Telefon" v-mask="'### ### ## ##'"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item label="TC Kimlik No" prop="vNo">
            <el-input v-model="data.vNo" v-mask="'###########'"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="24">
        <el-divider content-position="left">Kiracı Bilgi</el-divider>
        <el-col :span="8">
          <el-form-item label="İsim Soyisim" prop="kAdi">
            <el-input v-model="data.kAdi"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item label="Giriş Tarihi" prop="kgTarihi">
            <el-date-picker
              v-model="data.kgTarihi"
              type="date"
              placeholder=""
              format="dd.MM.yyyy">
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item label="Çıkış Tarihi" prop="kcTarihi">
            <el-date-picker
              v-model="data.kcTarihi"
              type="date"
              placeholder=""
              format="dd.MM.yyyy">
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item label="Telefon Numarası" prop="kTelefon">
            <el-input v-model="data.kTelefon" v-mask="'### ### ## ##'"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item label="TC Kimlik No" prop="kvNo">
            <el-input v-model="data.kvNo" v-mask="'###########'"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button type="success" :disabled="lo" size="medium" @click="Submit(true)" icon="el-icon-check">
        Kaydet ve Yeni Kayıt Ekle
      </el-button>
      <el-button type="primary" size="medium" @click="ModalKapat()" icon="el-icon-finished">
        Tamamla
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
  export default {
    props: {
      ModalOlayi: Boolean,
      Bina_id: String
    },
    data() {

      return {
        lo: false,
        Baslik: "Manuel Mesken Ekleme",
        data: {
          kNo: 1,
          Kat: 1,
          m2: 100,
          gTarihi: null,
          cTarihi: null,
          Adi: null,
          Telefon: null,
          vNo: null,
          kgTarihi: null,
          kcTarihi: null,
          kAdi: null,
          kTelefon: null,
          kvNo: null
        },
        Kayitlar: [],
        KayitlarDurum: null,
        FormHata: {
          kNo: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
          Kat: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
          m2: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
          gTarihi: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
          cTarihi: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
          Adi: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
          Telefon: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
        },
      }
    },
    methods: {
      ModalKapat() {
        this.$emit('ModalOlayi', false);
        location.reload();
      },
      Submit(durum) {
        this.$refs['Form'].validate((valid) => {
          if (valid) {
            this.lo = true;
            this.$message.info("Mesken Ekleniyor");
            // EKLE
            this.$store.dispatch("Post", {...this.data, path: 'yonetim/kurulum/mesken/' + this.Bina_id})
              .then(response => {
                this.lo = false;
                if (response.Durum == "OK") {
                  this.$message.success(response.Mesaj);
                  if (durum) {
                    this.Kayitlar = response.Veri;
                    this.data.kNo = Number(this.data.kNo) + 1;
                    this.data.Adi = null;
                    this.data.Telefon = null;
                    this.data.vNo = null;
                    this.data.kAdi = null;
                    this.data.kTelefon = null;
                    this.data.kvNo = null;
                    this.KayitlarDurum = true
                  } else {
                    this.ModalOlayi = false;
                    location.reload();
                  }
                } else {
                  this.$message.error(response.Mesaj);
                  this.hata = response.Hata;
                }
              })
          }
        });

      },
    },
    created() {
      var Gun = new Date();
      this.data.gTarihi = new Date(Gun.getFullYear(), Gun.getMonth(), 1);
      this.data.cTarihi = new Date(Gun.getFullYear() + 10, Gun.getMonth(), 0);
      this.data.kgTarihi = new Date(Gun.getFullYear(), Gun.getMonth(), 1);
      this.data.kcTarihi = new Date(Gun.getFullYear() + 1, Gun.getMonth(), 0);


    },
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Pack/Yonetim/bina/MeskenFormModal.vue